import { render, staticRenderFns } from "./DirectIncoming.vue?vue&type=template&id=73a6275b&scoped=true&"
import script from "./DirectIncoming.vue?vue&type=script&lang=js&"
export * from "./DirectIncoming.vue?vue&type=script&lang=js&"
import style0 from "./DirectIncoming.vue?vue&type=style&index=0&id=73a6275b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6275b",
  null
  
)

export default component.exports